module.exports = "a {\r\n  text-decoration: none;\r\n  color: white;\r\n}\r\n\r\na:hover, a:active {\r\n  color: lightblue;\r\n}\r\n\r\n.navigation-items {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/navigation/header/header.component.css
// module id = ./src/app/navigation/header/header.component.css
// module chunks = main